import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import AmexImg from '../assets/images/amex.svg';
import VisaImg from '../assets/images/visa.svg';
import MastercardImg from '../assets/images/mastercard.svg';
import DiscoverImg from '../assets/images/discover.svg';
import BankImg from "../assets/images/bank.svg";
import CardImg from '../assets/images/card.svg';
import successLogo from "../assets/images/success-logo.svg";
import failedLogo from "../assets/images/failed-logo.svg";
import alertLogo from "../assets/images/alert-logo.svg";


const paymentImages = [
        { src: AmexImg, name: 'American Express' },
        { src: VisaImg, name: 'Visa' },
        { src: MastercardImg, name: 'MasterCard' },
        { src: DiscoverImg, name: 'Discover' },
        { src : CardImg, name: 'default'},
        { src: BankImg, name: 'ACH' }    
];


export default function Result({ isResult }) {

const getPaymentImage = (type) => {
    if (!type) return CardImg; 

    const imageObj = paymentImages.find(
        (img) => img.name.toLowerCase() === type.toLowerCase()
    );
    return imageObj ? imageObj.src : CardImg; 
};


return (
        <>
        <style>
        {`
          .receipt-body > div:not(:last-child) {
            border-bottom: 1px solid #dee2e6;
          }
            @media (max-width: 576px) {
        .receipt-container { padding: 1.5rem !important; }
      }
        `}
      </style>
        <Row className="mt-2 mb-3 justify-content-center justify-content-md-start">
          <Col xs={11} sm={10} md={8} lg={7}>
            <div className="receipt-container p-4 rounded-3 border" style={{ borderColor: '#dee2e6', backgroundColor: '#fff' }}>
            
                {/*  Status */}
                <div className="text-center mb-2 pt-2">
                { isResult.transaction === 'Failed' ? ( isResult?.error ?  <><img src={alertLogo} alt="" /></>  : <><img src={failedLogo} alt="" /></>) : <><img src={successLogo} alt="" /></> }
                
                <h4 className="mt-2 fw-bold" style={{ color:  isResult.transaction === 'Failed' ?  "#FF3D00" : '#2AAE00' }}>{`${isResult.transaction === 'Failed' ? (isResult?.error ? 'System Failed To Transaction' : 'Transaction Declined') : 'Transaction Successful'}`}</h4>
                </div>

                {/* Amount Section */}
                {isResult.amount && <div className="text-center mb-4">
                    <p className="fs-6 mb-0" style={{ color: '#8F9BA3' }}>Amount</p>
                    <h2 className="fw-bold fs-4" style={{ color: '#003566' }}>${isResult.amount}</h2>
                    {isResult.transactionDate && <p className="mb-0" style={{ fontSize: 14, color: '#444' }}>{isResult.transactionDate}</p> }
                </div>}

                {/* Information Grid (Left-Right) */}
                <div className="receipt-body" style={{ fontSize: 14 }}>
            

                    {isResult.transactionId && isResult.transactionId !== '0' && (
                        <div className="d-flex justify-content-between align-items-center  py-2">
                            <span className="fw-semibold">Transaction ID:</span>
                            <span>{isResult.transactionId}</span>
                        </div>
                    )}

                    {isResult.invoiceNumber && (
                        <div className={`d-flex justify-content-between align-items-center py-2`}>
                            <span className="fw-semibold">Invoice Number:</span>
                            <span>{isResult.invoiceNumber}</span>
                        </div>
                    )}

                    {isResult.poNumber && (
                        <div className={`d-flex justify-content-between align-items-center py-2`}>
                            <span className="fw-semibold">PO Number:</span>
                            <span>{isResult.poNumber}</span>
                        </div>
                    )}

                    {isResult?.cardHolderName && (
                        <div className="d-flex justify-content-between align-items-center  py-2">
                            <span className="fw-semibold">Card Holder Name:</span>
                            <span>{isResult.cardHolderName}</span>
                        </div>
                    )}

                    {isResult?.achHolderName && (
                        <div className="d-flex justify-content-between align-items-center  py-2">
                            <span className="fw-semibold">Name on Account:</span>
                            <span>{isResult.achHolderName}</span>
                        </div>
                    )}

                    {isResult.customerNumber && (
                        <div className="d-flex justify-content-between align-items-center  py-2">
                            <span className="fw-semibold">Payment Method:</span>
                            <span>
                                {`****${isResult.customerNumber.slice(-4)}`}
                                <img src={getPaymentImage(isResult.paymentType)} alt="" style={{ width: '30px', marginLeft: '6px' }}/>
                            </span>
                        </div>
                    )}

                    { isResult.transaction === 'Approved' && isResult.approvalCode && (
                        <div className="d-flex justify-content-between align-items-center py-2">
                            <span className="fw-semibold">Approval Code:</span>
                            <span>{isResult.approvalCode}</span>
                        </div>
                    )}
                    
                    {isResult.avsResponse && (
                        <div className={`d-flex justify-content-between align-items-center py-2`} >
                            <span className="fw-semibold">AVS Response:</span>
                            <span>{isResult.avsResponse}</span>
                        </div>
                    )}

                    { isResult.transaction === 'Failed' && ( isResult.messageDetail || isResult.message ) && (
                        <div className="d-flex justify-content-between align-items-center py-2">
                            <span className="fw-semibold">Response Details:</span>
                            <span>{isResult.messageDetail === "NA" ? isResult.message : isResult.messageDetail}</span>
                        </div>
                    )}
                    
                    {isResult.transaction === 'Failed' && isResult.error && (
                        <div className="d-flex flex-column align-items-center justify-content-center py-4 px-3 text-center w-100">
                            <div className=" d-flex align-items-center" role="alert" style={{ maxWidth: '500px' }}>
                                <span className="fw-medium">
                                    We are unable to process your transaction at the moment due to a system exception occurred. Please try again some time.
                                </span>
                            </div>
                        </div>
                    )}

                    
                </div>
            </div>

           {/* New Payment Button */}
           <Row className="mt-3 mb-2">
            <Col className="text-end">
            <Button type="submit" className="payment-button w-100" variant="primary" onClick={() => { window.location.hash = ""; window.location.reload(); }}>New Payment</Button>
            </Col>
           </Row>
         </Col>
        </Row>
       </>
    )
}
